import InputLabelStyled from "@/components/InputLabelStyled";
import { useMusicalInstruments } from "@/lib/api";
import theme from "@/styles/theme";
import { Autocomplete, Chip, Skeleton, TextField, Typography } from "@mui/material";
import {useContext, useEffect, useState} from "react";
import AppContext from "@/context/AppContext";

const autocomplete = {
  "& .MuiFilledInput-root": {
    padding: ".1875rem 0 .1875rem 1rem",
    minHeight: "42px",
    "& ::placeholder": {
      color: "#1a1a1a",
      opacity: "1!important",
      textTransform: "uppercase",
      fontSize: "1rem",
    },

    "& input": {
      padding: "unset !important",
    },

    "& .MuiChip-root": {
      height: "1.75rem",
      borderRadius: ".25rem",
      color: theme.palette.common.white,
      margin: ".1875rem .5rem .1875rem 0",
      backgroundColor: theme.palette.primary.main,
    },
  },

  "& label": {
    display: "none",
  },
};

const chip = {
};

export const MusicalInstrumentSelectorMultiple = ({
  name = "musical_instruments", required = false,
  defaultValue,
  label,
  hint,
  onChange,
  helpertext,
    maxCount = 5
}) => {

  const {setSnackbar} = useContext(AppContext);
  const [selectedValues, setSelectedValues] = useState([]);
  const { instruments, isLoading, isError } = useMusicalInstruments();
  const [helper, setHelper] = useState('Bitte auswählen');

  useEffect(() => {
    if (selectedValues.length > maxCount) {
      setSnackbar({ type: 'warning', content: `Du kannst nur maximal ${maxCount} Instrumente wählen, alle weiteren werden nicht gespeichert`});
    }
    if (selectedValues.length === maxCount) {
      setHelper(`Du kannst maximal ${maxCount} Instrumente wählen`)
    } else {
      setHelper('Bitte auswählen');
    }
  }, [selectedValues]);

  const handleSelected = (event, values) => {
    let ids = [];
    for (const v of values) {
        ids = [...ids, v.id];
    }

    setSelectedValues(values);

    if (onChange) {
      event.target.name = name;
      event.target.value = ids;
      onChange(event, ids)
    }
  };

  if (isLoading || isError) {
      return <Skeleton />
  }

  return (
    <>
      <InputLabelStyled label={label} hint={hint} required={required} />
      <Autocomplete
        multiple
        sx={autocomplete}
        name={name}
        options={instruments}
        defaultValue={defaultValue}
        getOptionLabel={(option) => option.name}
        onChange={(event, newValues) => {
          if (newValues.length > maxCount) {
            newValues.pop();
          }
          handleSelected(event, newValues);
        }}

        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              sx={chip}
              label={option.name}
              key={index}
              {...getTagProps({index})}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="filled"
            placeholder={helper}
          />
        )}
      />
      {helpertext && (
        <Typography variant="helperText" component="p">
          {helpertext}
        </Typography>
      )}
    </>
  );
};
